import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FlexContainer, Icon } from 'components';
import styles from './GoToItem.module.scss';

/**
 * GoToItem
 *
 * @return {JSX.Element}
 */
const GoToItem = ({ className, external, to, onClick, children, ...rest }) => {
  const Component = onClick ? 'button' : external ? 'a' : Link;
  const props = onClick
    ? {
        ...rest,
        onClick,
      }
    : {
        ...rest,
        [external ? 'href' : 'to']: to,
      };

  return (
    <Component
      className={classNames(
        styles.GoToItem,
        className,
        `${GoToItem.displayName}`
      )}
      {...props}
    >
      <FlexContainer flex>{children}</FlexContainer>
      <Icon className={styles.Icon} name="goto" />
    </Component>
  );
};

GoToItem.displayName = 'GoToItem';

export default GoToItem;
